// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1vm1r","colMin":"styles_colMin__1mRX9","colCheckbox":"styles_colCheckbox__2CPkR"};